"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var drop_down_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/navigation/drop_down.svg"));

var tip_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/navigation/tip.svg"));

var done_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/status/done.svg"));

var error_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/status/error.svg"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var handleEvent_1 = require("../assets/handleEvent");

var modsClassName_1 = require("../assets/modsClassName");

var Avatar_1 = __importDefault(require("../Avatar/Avatar"));

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var fillIcon_1 = require("../helpers/fillIcon");

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Text_1 = __importDefault(require("../Text/Text"));

var ExpansionItem_styles_1 = require("./ExpansionItem.styles");

var doneIcon = fillIcon_1.fillIcon(done_svg_1.default, {});
var errorIcon = fillIcon_1.fillIcon(error_svg_1.default, {});
var tipIcon = fillIcon_1.fillIcon(tip_svg_1.default, {});
doneIcon.attrs.testname = 'done';
errorIcon.attrs.testname = 'error';
tipIcon.attrs.testname = 'tip';
var TYPE_ICONS = {
  success: doneIcon,
  warning: errorIcon,
  unknown: tipIcon
};

var ExpansionItem =
/** @class */
function (_super) {
  __extends(ExpansionItem, _super);

  function ExpansionItem(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isUnfolded: false
    };
    /**
     * Элемент, высоту которого мы изменяем, чтобы достичь эффекта схлопывания
     */

    _this.body = null;
    /**
     * Элемент с контентом карточки
     */

    _this.contentWrapper = null;
    /**
     * Значение, которое указывает, как в действительности выглядит элемент
     */

    _this.actualUnfolded = false;

    _this.handleClick = function () {
      var _a = _this,
          _b = _a.props,
          onToggle = _b.onToggle,
          disabled = _b.disabled,
          unfolded = _a.unfolded;

      if (disabled) {
        return;
      }

      var isUnfolded = !unfolded;

      _this.setState({
        isUnfolded: isUnfolded
      });

      handleEvent_1.handleEvent(onToggle, isUnfolded);
    };

    _this.handleTransitionEnd = function () {
      var actualUnfolded = _this.actualUnfolded;

      if (actualUnfolded) {
        // По окончанию перехода, необходимо сбросить значение height у body в auto
        _this.updateBodySize();
      }

      handleEvent_1.handleEvent(_this.props.onTransitionEnd, actualUnfolded);
    };

    _this.setBodyElement = function (body) {
      _this.body = body;
    };

    _this.setContentWrapperElement = function (contentWrapper) {
      _this.contentWrapper = contentWrapper;
    };

    _this.updateBodySize = function (height) {
      /* istanbul ignore next */
      if (!_this.body) {
        return;
      }

      _this.body.style.height = typeof height === 'number' ? height + "px" : 'auto'; // читаем свойство, чтобы вызвать пересчёт DOM
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      _this.body.clientHeight;
    };

    _this.actualUnfolded = _this.unfolded;
    return _this;
  }

  Object.defineProperty(ExpansionItem.prototype, "unfolded", {
    get: function get() {
      var isUnfolded = this.state.isUnfolded;
      var _a = this.props,
          emptyBody = _a.emptyBody,
          onToggle = _a.onToggle,
          unfolded = _a.unfolded,
          statical = _a.statical;

      if (statical) {
        return true;
      } // если есть onToggle или emptyBody — управляем сверху


      return onToggle || emptyBody ? unfolded : isUnfolded;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ExpansionItem.prototype, "bodyHeight", {
    get: function get() {
      /* istanbul ignore next */
      return this.body ? this.body.clientHeight : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ExpansionItem.prototype, "contentWrapperHeight", {
    get: function get() {
      /* istanbul ignore next */
      return this.contentWrapper ? this.contentWrapper.clientHeight : 0;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Сворачивает или разворачивает элемент
   * @param {boolean} unfolded - необходимое значение
   */

  ExpansionItem.prototype.toggleUnfolded = function (unfolded) {
    var actualUnfolded = this.actualUnfolded;

    if (unfolded === actualUnfolded) {
      return;
    }

    var _a = this,
        bodyHeight = _a.bodyHeight,
        contentWrapperHeight = _a.contentWrapperHeight;

    if (unfolded) {
      this.updateBodySize(bodyHeight);
      this.updateBodySize(contentWrapperHeight);
    } else {
      this.updateBodySize(bodyHeight);
      this.updateBodySize(0);
    }

    this.actualUnfolded = unfolded;
  };

  ExpansionItem.prototype.render = function () {
    var _a, _b, _c, _d, _e;

    var _f = this,
        props = _f.props,
        unfolded = _f.unfolded;

    var classes = props.classes,
        responsive = props.responsive,
        header = props.header,
        icon = props.icon,
        type = props.type,
        statical = props.statical,
        emptyBody = props.emptyBody,
        content = props.content,
        children = props.children,
        footer = props.footer,
        dangerouslyApplyHoverStyle = props.dangerouslyApplyHoverStyle;
    var itemClassName = classnames_1.default(classes.item, modsClassName_1.modsClassName(props, 'disabled'), (_a = {}, _a[classes.mobile] = responsive === 'mobile', _a[classes.auto] = responsive === 'auto', _a));
    var headerIcon = icon || TYPE_ICONS[type] || null;
    var headerClassName = classnames_1.default(classes.header, (_b = {}, _b[classes.unfolded] = unfolded, _b[classes.hover] = dangerouslyApplyHoverStyle, _b[classes.statical] = statical === true, _b));
    var bodyClassName = classnames_1.default(classes.body, (_c = {}, _c[classes.unfolded] = unfolded, _c[classes.leftMargin] = headerIcon !== null, _c));
    var contentWrapperClassName = classnames_1.default(classes.contentWrapper, (_d = {}, _d[classes.unfolded] = unfolded, _d[classes.leftMargin] = headerIcon !== null, _d[classes.emptyBody] = emptyBody, _d));
    var contentBorderClassName = classnames_1.default(classes.contentBorder, (_e = {}, _e[classes.leftMargin] = headerIcon !== null, _e));
    this.toggleUnfolded(unfolded);
    return react_1.default.createElement("div", __assign({}, baseProps_1.default(props), {
      className: itemClassName
    }), header && react_1.default.createElement("div", {
      "data-test-id": "expansion-item-header",
      className: headerClassName,
      onClick: this.handleClick
    }, headerIcon && react_1.default.createElement("div", {
      "data-test-id": type ? "expansion-icon-" + type : 'expansion-icon',
      className: classes.headerIcon
    }, react_1.default.createElement(Avatar_1.default, {
      small: true,
      success: type === 'success',
      warning: type === 'warning',
      icon: headerIcon
    })), react_1.default.createElement("div", {
      "data-test-id": "expansion-item-header-text",
      className: classes.headerText
    }, react_1.default.createElement(Text_1.default, null, header)), !statical && react_1.default.createElement("div", {
      className: classes.dropDownIcon
    }, react_1.default.createElement(Icon_1.default, {
      icon: drop_down_svg_1.default,
      upsidedown: unfolded
    }))), react_1.default.createElement("div", {
      "data-test-id": "expansion-item-body",
      className: bodyClassName,
      ref: this.setBodyElement,
      onTransitionEnd: this.handleTransitionEnd
    }, !emptyBody && react_1.default.createElement("div", {
      className: contentBorderClassName
    }), react_1.default.createElement("div", {
      className: contentWrapperClassName,
      ref: this.setContentWrapperElement
    }, content || children, !!footer && react_1.default.createElement("div", {
      "data-test-id": "expansion-item-footer"
    }, footer))));
  };

  ExpansionItem = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(ExpansionItem_styles_1.styles)], ExpansionItem);
  return ExpansionItem;
}(react_1.default.PureComponent);

exports.default = ExpansionItem;